var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 109,
    viewBox: "0 0 203 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 109H4.87333V0H0V109ZM14.6262 109H24.1794V0H14.6262V109ZM33.7327 109H43.4855V0H33.7327V109ZM53.0388 109H72.5383V0H53.0388V109ZM82.0915 109H96.7178V0H82.0915V109ZM106.271 109H116.024V0H106.271V109ZM125.577 109H130.45V0H125.577V109ZM140.203 109H149.757V0H140.203V109Z",
    fill: "#88869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0784 109H57.9517V0H53.0784V109ZM67.7046 109H77.2578V0H67.7046V109ZM86.811 109H96.5639V0H86.811V109ZM106.117 109H125.617V0H106.117V109ZM135.17 109H149.796V0H135.17V109ZM159.349 109H169.102V0H159.349V109ZM178.655 109H183.529V0H178.655V109ZM193.282 109H202.835V0H193.282V109Z",
    fill: "#88869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.1a9ff498894b1fc03a99d8f5c1aa698d.svg";
export { ForwardRef as ReactComponent };